import {
  defaultOrgTypesDataReceiver,
  operationAgeFilter,
  operationAgeFilterSelection,
  operationsTypesFilter,
  operationsTypesFilterSelection,
  orgTypesFilter,
  orgTypesFilterSelection,
  orgsFilter,
  orgsFilterSelection,
  periodFilter,
} from 'app/dataProviders/filter-items'


export const filterInit = () => {
  orgTypesFilter.addDataReceiver(
    defaultOrgTypesDataReceiver,
  )
  orgTypesFilter.dataReceive()
  orgTypesFilter.setStatusReady()


  return () => {
    orgsFilterSelection.reset()
    orgTypesFilterSelection.reset()
    operationsTypesFilterSelection.reset()
    operationAgeFilterSelection.reset()

    orgsFilter.reset()
    orgTypesFilter.reset()
    periodFilter.reset()
    operationsTypesFilter.reset()
    operationAgeFilter.reset()
  }
}

export const resetToDefaultAll = () => {
  orgsFilterSelection.resetToDefault()
  orgTypesFilterSelection.resetToDefault()
  operationsTypesFilterSelection.resetToDefault()
  operationAgeFilterSelection.resetToDefault()
  periodFilter.resetToDefault()
}
